import React, { createContext, useContext, useState, useCallback } from "react";
import { translations } from "@/i18n/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(() => {
    const saved = typeof window !== "undefined" ? localStorage.getItem("evermin_lang") : null;
    return saved === "hi" ? "hi" : "en";
  });

  const setLanguage = useCallback((lang) => {
    const next = lang === "hi" ? "hi" : "en";
    setLanguageState(next);
    localStorage.setItem("evermin_lang", next);
  }, []);

  const toggleLanguage = useCallback(() => {
    setLanguageState((prev) => {
      const next = prev === "en" ? "hi" : "en";
      localStorage.setItem("evermin_lang", next);
      return next;
    });
  }, []);

  const t = useCallback(
    (key) => translations[language]?.[key] ?? translations.en[key] ?? key,
    [language]
  );

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
}
